module.exports = __webpack_public_path__ + "img/whois-team.e0a60834.jpg";